
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/preorder/young-washington",
      function () {
        return require("private-next-pages/[locale]/preorder/young-washington/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/preorder/young-washington"])
      });
    }
  